export const getTimeOptions = () => {
  const minutes = [0, 15, 30, 45];
  let options: {
    value: number;
    label: string;
  }[] = [];

  // eslint-disable-next-line fp/no-loops
  for (let hour = 6; hour < 24; hour++) {
    options = options.concat(
      minutes.map((minute) => ({
        value: hour * 100 + minute,
        label: `${hour}:${minute >= 0 && minute <= 9 ? `0${minute}` : minute}`,
      })),
    );
  }
  return options;
};
